import { BASESCAN_URL } from '#src/config.ts';

export const txLink = (txHash: string) => `${BASESCAN_URL}/tx/${txHash}`;
